<template>
  <div class="blog-detail-wrapper">

    <!-- blogs -->
    <b-row class="blog-list-wrapper">
      <b-card no-body class="col-md-12">
        <b-card-header class="pb-50">
          <h5>
            Фильтры
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col
                cols="12"
                md="4"
                class="mb-1"
            >
              <label for="search-query">Запрос</label>
              <b-form-input
                  id="search-query"
                  v-model="searchQuery"
                  placeholder="Зеленая миля"
                  :debounce="400"
                  @update="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="4"
                class="mb-1"
            >
              <label for="filter-type">Тип</label>
              <b-form-select
                  id="filter-type"
                  v-model="filterType"
                  :options="typeOptions"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="4"
                class="mb-1"
            >
              <label for="sort-select">Сортировка</label>
              <b-form-select
                  id="sort-select"
                  v-model="sortValue"
                  :options="sortOptions"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="2"
                class="mb-1"
            >
              <label for="filter-year-from">Год от</label>
              <b-form-input
                  id="filter-year-from"
                  v-model.number="filterYearFrom"
                  type="number"
                  placeholder="1990"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="2"
                class="mb-1"
            >
              <label for="filter-year-to">Год до</label>
              <b-form-input
                  id="filter-year-to"
                  v-model.number="filterYearTo"
                  type="number"
                  placeholder="2026"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="2"
                class="mb-1"
            >
              <label for="filter-genre">Жанр</label>
              <b-form-input
                  id="filter-genre"
                  v-model="filterGenre"
                  placeholder="боевик"
                  :debounce="400"
                  @update="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="2"
                class="mb-1"
            >
              <label for="filter-country">Страна</label>
              <b-form-input
                  id="filter-country"
                  v-model="filterCountry"
                  placeholder="США"
                  :debounce="400"
                  @update="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="1"
                class="mb-1"
            >
              <label for="filter-rating-kp-min">КП от</label>
              <b-form-input
                  id="filter-rating-kp-min"
                  v-model.number="filterRatingKpMin"
                  type="number"
                  step="0.1"
                  placeholder="7"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="1"
                class="mb-1"
            >
              <label for="filter-votes-kp-min">Оценок от</label>
              <b-form-input
                  id="filter-votes-kp-min"
                  v-model.number="filterVotesKpMin"
                  type="number"
                  placeholder="10000"
                  @change="fetchMoviesList()"
              />
            </b-col>
            <b-col
                cols="6"
                md="2"
                class="mb-1"
            >
              <label for="filter-has-franchise">Франшиза</label>
              <b-form-select
                  id="filter-has-franchise"
                  v-model="filterHasFranchise"
                  :options="franchiseOptions"
                  @change="fetchMoviesList()"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-overlay
          :show="isLoading"
          rounded="sm"
      >
        <b-table
            ref="refMoviesListTable"
            :items="moviesList"
            responsive
            :fields="tableColumns"
            primary-key="id"
            show-empty
            empty-text="No matching records found"
            class="position-relative"
        >
          <!-- Column: Id -->
          <template #cell(id)="data">
            #{{ data.item.id }}
          </template>

          <!-- Column: Movie -->
          <template #cell(movie)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-link
                    :to="{name: 'movie-view', params: { id: data.item.id }}"
                >
                  <b-img
                      width="120"
                      thumbnail
                      rounded
                      fluid
                      class="poster"
                      :class="(isFilm(data.item.type)) ? 'poster-movie' : 'poster-series'"
                      :src="data.item.poster_preview"
                  />
                </b-link>
              </template>
              <span class="font-weight-bold d-block">
              <b-link
                  :to="{name: 'movie-view', params: { id: data.item.id }}"
                  class="h2"
                  :class="(isFilm(data.item.type)) ? 'title-movie' : 'title-series'"
              >{{ data.item.title_ru }}</b-link>
              <span
                  v-if="data.item.year"
                  class="movie-year text-muted ml-50"
              >{{ data.item.year }}</span>
                </span>
              <small class="text-muted">{{ data.item.title_en }}</small>
              <span
                  v-for="franchise in data.item.franchises"
                  :key="franchise.id"
                  class="d-block text-nowrap mt-25"
              >
                <b-link
                    :to="{name: 'franchise-view', params: {id: franchise.id}}"
                    class="franchise-chip"
                >
                  <feather-icon
                      icon="LayersIcon"
                      size="18"
                  />
                  <span>{{ franchise.title }}<template v-if="franchise.part_number"> · {{ franchise.part_number }}</template></span>
                </b-link>
              </span>
            </b-media>
          </template>

          <!-- Column: Type -->
          <template #cell(type)="data">
            <feather-icon :icon="GetTypeIcon(data.item.type)" v-b-tooltip.hover.top="data.item.type"/>
          </template>

          <!-- Column: Ratings (КП + IMDb одним блоком) -->
          <template #cell(ratings)="data">
            <div class="rating-block">
              <div class="rating-row">
                <b-link
                    v-if="data.item.kp_id"
                    :href="`https://kinopoisk.ru/film/${data.item.kp_id}`"
                    target="_blank"
                >
                  <b-img
                      :src="kinopoiskIcon"
                      class="rating-source-img rating-source-img-kp"
                      alt="КП"
                      v-b-tooltip.hover.top="'Открыть на Кинопоиске'"
                  />
                </b-link>
                <b-img
                    v-else
                    :src="kinopoiskIcon"
                    class="rating-source-img rating-source-img-kp"
                    alt="КП"
                />
                <span
                    class="font-weight-bold font-large-1 mr-50"
                    :class="ratingColorClass(data.item.rating_kp)"
                >{{ ratingFmt(data.item.rating_kp) }}</span>
                <small class="text-muted">{{ formatNumber(data.item.votes_kp) }}</small>
              </div>
              <div class="rating-row">
                <b-link
                    v-if="data.item.imdb_id"
                    :href="`https://www.imdb.com/title/${data.item.imdb_id}/`"
                    target="_blank"
                >
                  <b-img
                      :src="imdbIcon"
                      class="rating-source-img rating-source-img-imdb"
                      alt="IMDb"
                      v-b-tooltip.hover.top="'Открыть на IMDb'"
                  />
                </b-link>
                <b-img
                    v-else
                    :src="imdbIcon"
                    class="rating-source-img rating-source-img-imdb"
                    alt="IMDb"
                />
                <span
                    class="font-weight-bold mr-50"
                    :class="ratingColorClass(data.item.rating_imdb)"
                >{{ ratingFmt(data.item.rating_imdb) }}</span>
                <small class="text-muted">{{ formatNumber(data.item.votes_imdb) }}</small>
              </div>
            </div>
          </template>

          <!-- Column: Creation Date -->
          <template #cell(created_at)="data">
            <span class="text-nowrap mr-1">
               {{ formatDate(data.item.created_at) }}
            </span>
          </template>

          <!-- Column: Updated Date time -->
          <template #cell(updated_at)="data">
            <span class="text-nowrap mr-1">
               {{
                formatDate(data.item.updated_at, {
                  month: 'numeric',
                  day: 'numeric',
                  year: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric'
                })
              }}
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">

            <div class="text-nowrap">

            </div>
          </template>
        </b-table>
      </b-overlay>

      <b-col cols="12">
        <!-- pagination -->
        <div class="my-2">
          <b-pagination
              v-model="page"
              per-page="20"
              align="center"
              :total-rows="total"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-col>
    </b-row>

    <!--/ blogs -->

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BCardHeader,
  BTable,
  BButton,
  BFormSelect,
  VBTooltip,
  BOverlay,
} from 'bootstrap-vue'
import {avatarText, kFormatter, formatDate, ratingFmt, formatNumber} from '@core/utils/filter'
import store from "@/store";
import {onUnmounted, ref, watch} from "@vue/composition-api";
import movieStoreModule from "@/views/database/movieStoreModule";
import kinopoiskIcon from '@/assets/images/icons/kinopoisk.svg'
import imdbIcon from '@/assets/images/icons/imdb.svg'

export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BCardHeader,
    BTable,
    BButton,
    BFormSelect,
  },
  data() {
    return {
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  methods: {
    kFormatter,
    formatDate,
    ratingFmt,
    formatNumber,
    // Прежняя цветовая логика рейтинга: <5 красный, <7 серый, иначе зелёный
    ratingColorClass(rating) {
      return (rating < 5) ? 'text-danger' : (rating < 7) ? 'text-gray' : 'text-success'
    },
    GetTypeIcon(type) {
      if (type === 'FILM') {
        return 'FilmIcon'
      }
      if ((type === 'TV_SERIES') || (type === 'MINI_SERIES')) {
        return 'TvIcon'
      }
      if (type === 'TV_SHOW') {
        return 'CameraIcon'
      }
      if (type === 'UNKNOWN') {
        return 'InfoIcon'
      }
      if (type === 'VIDEO') {
        return 'VideoIcon'
      }
      return 'AlertTriangleIcon'
    },
    isFilm(type) {
      if (type === 'FILM') {
        return true
      }
      if ((type === 'TV_SERIES') || (type === 'MINI_SERIES')) {
        return false
      }
      if (type === 'TV_SHOW') {
        return false
      }
      if (type === 'UNKNOWN') {
        return false
      }
      if (type === 'VIDEO') {
        return true
      }
      return false
    }
  },
  setup() {
    const STORE_MODULE_NAME = 'movies'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, movieStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const page = ref(1)
    const searchQuery = ref(null)
    const total = ref(null)
    const isLoading = ref(false)

    // --- Фильтры ---
    const filterType = ref(null)
    const filterYearFrom = ref(null)
    const filterYearTo = ref(null)
    const filterGenre = ref(null)
    const filterCountry = ref(null)
    const filterRatingKpMin = ref(null)
    const filterVotesKpMin = ref(null)
    const filterHasFranchise = ref(null)

    const typeOptions = [
      {value: null, text: 'Все типы'},
      {value: 'FILM', text: 'Фильм'},
      {value: 'TV_SERIES', text: 'Сериал'},
      {value: 'MINI_SERIES', text: 'Мини-сериал'},
      {value: 'TV_SHOW', text: 'ТВ-шоу'},
      {value: 'VIDEO', text: 'Видео'},
    ]

    const franchiseOptions = [
      {value: null, text: 'Все'},
      {value: '1', text: 'Есть'},
      {value: '0', text: 'Нет'},
    ]

    // --- Сортировка: статичный селект вместо сортировки колонок ---
    const sortValue = ref('id:asc')
    const sortOptions = [
      {value: 'id:asc', text: 'ID (по умолчанию)'},
      {value: 'created_at:desc', text: 'Дата добавления: новые'},
      {value: 'created_at:asc', text: 'Дата добавления: старые'},
      {value: 'updated_at:desc', text: 'Дата изменения: свежие'},
      {value: 'year:desc', text: 'Год: новые'},
      {value: 'year:asc', text: 'Год: старые'},
      {value: 'rating_kp:desc', text: 'Рейтинг КП: по убыванию'},
      {value: 'rating_imdb:desc', text: 'Рейтинг IMDb: по убыванию'},
      {value: 'votes_kp:desc', text: 'Оценок КП: по убыванию'},
      {value: 'votes_imdb:desc', text: 'Оценок IMDb: по убыванию'},
      {value: 'title_ru:asc', text: 'Название: А–Я'},
    ]

    // Table Handlers
    const tableColumns = [
      {key: 'id', label: '#'},
      {key: 'movie', label: 'Фильм'},
      {key: 'type', label: 'Тип'},
      {key: 'ratings', label: 'Рейтинг'},
      {key: 'created_at', label: 'Дата добавления'},
      {key: 'updated_at', label: 'Дата изменения'},
    ]

    const moviesList = ref([])
    const fetchMovies = (...args) => store.dispatch('movies/fetchMovies', ...args)

    // В запрос уходят только заполненные фильтры
    const buildParams = () => {
      const [sortField, sortDirection] = sortValue.value.split(':')
      const params = {
        page: page.value,
        per_page: 20,
        sort: sortField,
        sortDesc: sortDirection === 'desc',
      }
      if (searchQuery.value) params.q = searchQuery.value
      if (filterType.value) params.type = filterType.value
      if (filterYearFrom.value) params.year_from = filterYearFrom.value
      if (filterYearTo.value) params.year_to = filterYearTo.value
      if (filterGenre.value) params.genre = filterGenre.value
      if (filterCountry.value) params.country = filterCountry.value
      if (filterRatingKpMin.value) params.rating_kp_min = filterRatingKpMin.value
      if (filterVotesKpMin.value) params.votes_kp_min = filterVotesKpMin.value
      if (filterHasFranchise.value !== null) params.has_franchise = filterHasFranchise.value
      return params
    }

    const fetchPage = () => {
      isLoading.value = true
      fetchMovies(buildParams())
          .then(response => {
            moviesList.value = response.data.data
            total.value = response.data.meta.total
            isLoading.value = false
          })
          .catch(() => {
            isLoading.value = false
          })
    }

    // Смена фильтра/сортировки сбрасывает на первую страницу; смену страницы ловит watch
    const fetchMoviesList = () => {
      if (page.value !== 1) {
        page.value = 1
        return
      }
      fetchPage()
    }

    fetchPage()

    watch(page, () => {
      fetchPage()
    })

    return {
      fetchMovies,
      tableColumns,
      searchQuery,
      filterType,
      filterYearFrom,
      filterYearTo,
      filterGenre,
      filterCountry,
      filterRatingKpMin,
      filterVotesKpMin,
      filterHasFranchise,
      typeOptions,
      franchiseOptions,
      sortValue,
      sortOptions,
      moviesList,
      page,
      total,
      avatarText,
      fetchMoviesList,
      isLoading,
      kinopoiskIcon,
      imdbIcon,
    }
  },
}
</script>

<style lang="scss">
.poster-movie {
  border-color: #006d8d;
}

.poster-series {
  border-color: #b97500;
}

.poster {
  border-width: 2px;
}

.title-movie {
  color: #006d8d;
}

.title-series {
  color: #b97500;
}

// Год отделён от названия и приглушён
.movie-year {
  font-size: 1.3rem;
  font-weight: 400;
}

// Объединённый блок рейтингов КП/IMDb
.rating-block {
  min-width: 160px;
}

.rating-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

// Иконки источников на фирменных плашках: белый глиф КП на оранжевом, чёрный IMDb на жёлтом
.rating-source-img {
  width: 26px;
  height: 26px;
  padding: 4px;
  margin-right: 8px;
  border-radius: 5px;
  flex-shrink: 0;
}

.rating-source-img-kp {
  background: #f50;
}

.rating-source-img-imdb {
  background: #f5c518;
}

// Плашка франшизы: свой chip вместо b-badge — у бэджа em-паддинги и line-height
// давят крупную иконку, тут размеры полностью под контролем
.franchise-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 0.358rem;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  font-size: 1.15rem;
  font-weight: 500;
  line-height: 1.2;

  svg {
    margin-right: 6px;
    flex-shrink: 0;
  }

  &:hover {
    background: rgba(115, 103, 240, 0.2);
    color: #7367f0;
  }
}
</style>